// INSIDO (20-mobile): phone layout state shared by the shell (src/Interface),
// the headers and the settings modal. Below the Panda `md` breakpoint
// (< 768px) the app shows one pane at a time: the rail + channel column become
// a left drawer and the member panel a right drawer. Both are ephemeral (not
// persisted in the layout store) so closing them on a phone never collapses the
// desktop sidebars.
import { createSignal } from "solid-js";

/** Same edge as Panda's `mdDown` condition */
export const PHONE_MEDIA_QUERY = "(max-width: 767.98px)";

const media =
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(PHONE_MEDIA_QUERY)
    : undefined;

const [isPhone, setIsPhone] = createSignal(media?.matches ?? false);
media?.addEventListener("change", (event) => setIsPhone(event.matches));

const [navOpen, setNavOpen] = createSignal(false);
const [membersOpen, setMembersOpen] = createSignal(false);

/**
 * Phone layout state
 */
export const mobileLayout = {
  /** Whether the viewport is phone-sized (< 768px) */
  isPhone,
  /** Whether the navigation drawer (rail + channel column) is open */
  navOpen,
  setNavOpen,
  toggleNav: () => setNavOpen((open) => !open),
  /** Whether the member drawer is open */
  membersOpen,
  setMembersOpen,
  toggleMembers: () => setMembersOpen((open) => !open),
};
